/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./index.vue.js?vue&type=template&id=a8d8f902&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=a8d8f902&scoped=true"
import script from "./index.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue.postcss?vue&type=style&index=0&id=a8d8f902&prod&lang=postcss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=a8d8f902&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d8f902",
  null
  
)

export default component.exports